import { render, staticRenderFns } from "./ViolationFormCallLog.vue?vue&type=template&id=f3a22452&"
import script from "./ViolationFormCallLog.vue?vue&type=script&lang=ts&"
export * from "./ViolationFormCallLog.vue?vue&type=script&lang=ts&"
import style0 from "./ViolationFormCallLog.vue?vue&type=style&index=0&id=f3a22452&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports